import { render, staticRenderFns } from "./AcreditadoCard.vue?vue&type=template&id=dae0e986&"
import script from "./AcreditadoCard.vue?vue&type=script&lang=js&"
export * from "./AcreditadoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports